import { Component } from 'react'
import { createPortal } from 'react-dom'

class Dialog extends Component {
    constructor(props) {
        super(props)
        this.dom = document.createElement('div')
        this.dom.setAttribute('id', 'portal')
        document.body.appendChild(this.dom)
    }

    render() {
        return createPortal(<>{this.props.children}</>, this.dom)
    }
}

export default Dialog